<template>
  <a-col :span="24">
    <a-form-item
      name="scientificScopes"
      label="Научные области"
      class="scopes_form_item"
      :help="errors.getError('scopes')"
      :validate-status="errors.getStatus('scopes')"
    >
      <c-input-udc-list
        :items="scopes"
        :disabled="disabled"
        @update="updateScopes"
      />
    </a-form-item>
  </a-col>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import { useRoute } from 'vue-router';
  import ErrorsHandler from '@/components/form/errors-handler';
  import CInputUdcList from '@/components/UI/CInputUdcList.vue';

  const api = useApi();
  const route = useRoute();
  const emit = defineEmits(['saved']);

  defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const scopes = ref([]);

  const errors = new ErrorsHandler(
    {
      scopes: '',
    },
    (fieldName) => {
      if ('udcList' === fieldName) {
        return 'scopes';
      }
      return fieldName;
    }
  );

  onMounted(async () => {
    await getScopes();
  });

  const getScopes = async () => {
    try {
      const response = await api.udc.index(
        new URLSearchParams({
          briefcaseId: route.params.id,
        })
      );
      scopes.value = response.udcList.items;
    } catch (error) {
      console.error('error', error);
    }
  };

  const onFinish = async () => {
    try {
      await api.briefcase.saveUdcList({
        briefcaseId: route.params.id,
        udcList: scopes.value,
      });

      await getScopes();
      emit('saved', true);
    } catch (error) {
      errors.handleApiErrors(error);
      emit('saved', false);
    }
  };

  const updateScopes = (udcList) => {
    scopes.value = [...udcList];
  };

  defineExpose({ onFinish });
</script>

<style lang="scss" scoped>
  @use '@/components/form/main-form.scss';

  .scopes_form_item {
    margin-bottom: 14px;
  }
</style>
